import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

import weekOfYear from "dayjs/plugin/weekOfYear";
dayjs.extend(weekOfYear);

import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(isoWeek);

import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const date = {
  dayjs,
  zeroUTCtime: (date) => {
    const temp = new Date(date);
    temp.setUTCHours(0, 0, 0, 0);

    return temp;
  },
  endUTCtime: (date) => {
    let tempDate = new Date(date);
    tempDate.setUTCHours(23, 59, 59, 999);
    return tempDate;
  },
  parse: (input, format, utc) => {
    if (utc) {
      return dayjs.utc(input, format).toDate();
    }
    return dayjs(input, format).toDate();
  },
  fromTimestamp: (timestamp) => {
    return dayjs(timestamp).toDate();
  },
  format: (date, format, utc) => {
    if (utc) {
      return dayjs(date).utc().format(format);
    }

    return dayjs(date).format(format);
  },
  diff: (start, end, unit) => {
    return dayjs(start).utc().diff(dayjs(end).utc(), unit, true);
  },
  add: (date, amount, unit) => {
    return dayjs(date).utc().add(amount, unit).toDate();
  },
  getWeek: (date) => {
    date = dayjs(date).utc();
    if (date.day() == 0) date = date.day(-1);

    return {
      from: date.day(1).startOf("day").toDate(),
      to: date.day(1).add(6, "days").endOf("day").toDate(),
    };
  },
  getMonday: (date) => {
    return dayjs(date).day(1);
  },
  getSunday: (date, unit) => {
    return dayjs(date).day(7);
  },
  getMonth: (date) => {
    date = dayjs(date).utc();

    return {
      from: date.startOf("month").toDate(),
      to: date.endOf("month").toDate(),
    };
  },
};

export default date;
